export const AUTH_MODAL_HASH_LOGIN = "login";
export const AUTH_MODAL_HASH_REGISTER = "register";
export const AUTH_MODAL_HASH_REGISTER_SSO = "register_sso";
